import { css } from 'emotion';
import { space } from '@joykit';
import { animationTransition } from '@joykit/variables';
import { getInterUIDynamicMetricCssObject } from 'fonts/Inter-UI/metrics';

export namespace styles {
  export const container = css({
    textAlign: 'center',
    ':not(:first-child)': {
      marginTop: 32
    }
  });
  export const message = css({
    color: '#888888',
    ...getInterUIDynamicMetricCssObject(13),
    ':not(:last-child)': {
      margin: space.stack.md
    }
  });
  export const button = css({
    ...getInterUIDynamicMetricCssObject(15),
    fontWeight: 600,
    width: '100%',
    padding: space.squishInset.md,

    border: '2px solid #484848',
    color: '#484848',
    backgroundColor: 'white',
    transition: animationTransition('background-color', 'color'),
    ':hover': {
      borderColor: '#333',
      backgroundColor: 'rgba(0,0,0, 0.8)',
      color: 'white'
    }
  });
}
